module.exports = __webpack_public_path__ + "img/award_yes.64bfe0ab.png";